import { Label } from "@/components/ui/label";
import React from "react";
import packageJson from "../../../package.json";

const Footer: React.FC = () => {
  return (
    <footer className="footer hide-from-third-app flex max-h-[20px] min-w-[400px] flex-row items-center justify-between gap-2 py-4">
      {/* <p>© 2025 zConnect Health</p> */}

      <Label className="">Powered by ©2025 zConnect Health</Label>
      <Label className="">
        {packageJson.version} ({packageJson.buildnumber})
      </Label>
    </footer>
  );
};

export default Footer;
